export default __webpack_public_path__ + "static/media/404.1b5c0f35.jpg";